export default __webpack_public_path__ + "static/media/twit logo 1.417cdd77.svg";